module.exports = __webpack_public_path__ + "img/loginpagelogo1.83340934.png";